import { Badge } from '@one-thd/sui-atomic-components';
import React from 'react';
import { isBopisOutOfStockRecoverable } from '../../order-details/util/FulfillmentStatus';
import { FeatureSwitches } from '../../../constants/feature-switches';
export var PHOrderBadge = function (_a) {
    var _b, _c, _d;
    var deliveryTrackerData = _a.deliveryTrackerData, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, preShip = _a.preShip;
    var status = (_d = (_c = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.statusDescription) !== null && _d !== void 0 ? _d : '';
    var successStatuses = [
        'Being Processed',
        'Processed',
        'Shipped',
        'In-Transit',
        'Reserved',
        'Out for Delivery',
        'On Schedule',
    ];
    var isBopisOosRecoverable = FeatureSwitches.enableBopisOutOfStockRecoverability &&
        fulfillmentGroup &&
        (fulfillmentType === 'BuyOnlinePickupInStore' ||
            fulfillmentType === 'BOPIS') &&
        isBopisOutOfStockRecoverable(fulfillmentGroup);
    if ((fulfillmentType === 'InStorePurchase' ||
        fulfillmentType === 'unavailable' ||
        status === 'Canceled' ||
        status === 'Delivered' ||
        status === 'Complete' ||
        (deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) === 'DELIVERED' ||
        (!successStatuses.includes(status) && status !== 'See Order Details')) &&
        !isBopisOosRecoverable) {
        return null;
    }
    var badgeColor = function () {
        if (status === 'See Order Details' ||
            (deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) === 'DELAYED' ||
            isBopisOosRecoverable)
            return 'warning';
        if (['On Schedule', 'Processed'].includes(status) || preShip)
            return 'primary';
        if (successStatuses.includes(status))
            return 'success';
        return null;
    };
    return (React.createElement("div", { style: {
            marginBottom: '16px',
        } },
        React.createElement(Badge, { variant: "subtle", style: { textTransform: 'capitalize', fontSize: '12px' }, size: "base", color: badgeColor() }, (function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            if ((deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) === 'DELAYED') {
                return 'Delayed';
            }
            if (preShip ||
                ((_b = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.statusDescription) ===
                    'On Schedule') {
                return 'Processed';
            }
            if (((_d = (_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.statusDescription) ===
                'Return Initiated') {
                return 'Initiated';
            }
            if (isBopisOosRecoverable) {
                return 'Options Available';
            }
            if (deliveryTrackerData !== undefined) {
                if (((_e = deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) !== null && _e !== void 0 ? _e : '') === 'OUT_FOR_DELIVERY') {
                    return 'Out for Delivery';
                }
                return ((_f = deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) !== null && _f !== void 0 ? _f : '')
                    .split('_')
                    .join(' ')
                    .toLowerCase();
            }
            if (((_h = (_g = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.statusDescription) === 'Shipped') {
                return 'Shipped';
            }
            if (((_k = (_j = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.statusDescription) ===
                'Ready for Pickup') {
                return 'Ready for Pickup';
            }
            if (((_m = (_l = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.statusDescription) === 'Delivered') {
                return 'Delivered';
            }
            return (_p = (_o = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.statusDescription;
        })())));
};
